import { render, staticRenderFns } from "./pay_result.vue?vue&type=template&id=acfaacca&scoped=true&"
import script from "./pay_result.vue?vue&type=script&lang=js&"
export * from "./pay_result.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acfaacca",
  null
  
)

export default component.exports